import { ref } from 'vue'

export type LoadingSize = 'small' | 'full'

const isLoading = ref(false)
const loadingMessage = ref('')
const loadingSize = ref<LoadingSize>('full')

export function useLoading() {
  return {
    isLoading,
    loadingMessage,
    loadingSize,
    showLoading: () => (isLoading.value = true),
    hideLoading: () => (isLoading.value = false),
    setLoadingMessage: (message: string) => (loadingMessage.value = message),
    setLoadingSize: (size: LoadingSize) => (loadingSize.value = size),
  }
}
